import { lazy } from 'react';

const Otp = lazy(() => import(/* webpackChunkName: "OTP-Main" */ './OtpMain'));

export default Otp;
